import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">Tech Stack for WordPress Development</h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>Here is our tech stack for WordPress development services:</p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Programming Languages">
              <ul>
                <li>HTML</li>
                <li>CSS</li>
                <li>JavaScript</li>
                <li>PHP</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="DataBases">
              <ul>
                <li>Plesk</li>
                <li>cPanel</li>
                <li>phpMyAdmin</li>
                <li>MySQL Client</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Frameworks">
              <ul>
                <li>Bootstrap</li>
                <li>Angular </li>
                <li>VUE.JS</li>
                <li> Next.JS</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
